import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Subject } from 'rxjs';
import { BASE_URL } from './base-url';

@Injectable({ providedIn: 'root' })
export class ApiService {
  // environment.apiBase should be like "http://localhost:8000/api"
  // base = environment.apiBase.replace(/\/api\/?$/, '/api'); // ensure /api base

  // base = "http://3.110.47.76:8000/api"

  base = "https://monitordev.anikinitek.com/api"

  fcbase = "https://objectdetection.anikinitek.com/api/"


  connected = false;
  nvrInfo: any = null;

  constructor(private http: HttpClient) { }

  // small helper to get base origin (without /api)
  getStreamsBase(): string {
    let backendOrigin = this.base;
    if ((backendOrigin as string).endsWith('/api')) {
      backendOrigin = (backendOrigin as string).slice(0, -4);
    }
    if ((backendOrigin as string).endsWith('/api/')) {
      backendOrigin = (backendOrigin as string).slice(0, -5);
    }
    return backendOrigin as string;
  }

  connectNvr(payload: any) {
    return this.http.post(`${this.base}/connect`, payload);
  }

  disconnectNvr() {
    return this.http.post(`${this.base}/disconnect`, {});
  }

  getChannels(payload: {
    ip: string;
    username: string;
    password: string;
  }) {
    return this.http.post(`${this.base}/channels`, payload);
  }

  startStream(payload: {
    ip: string;
    username: string;
    password: string;
    channel_id: string;
  }) {
    return this.http.post(`${this.base}/stream/start`, payload);
  }

  stopStream(payload: {
    ip: string;
    username: string;
    password: string;
    channel_id: string;
  }) {
    return this.http.post(`${this.base}/stream/stop`, payload);
  }

  startAllStreams() {
    return this.http.post(`${this.base}/stream/start_all`, {});
  }

  stopAllStreams() {
    return this.http.post(`${this.base}/stream/stop_all`, {});
  }

  getHistory(cameraId: string) {
    return this.http.get(`${this.base}/history/${cameraId}`);
  }

  setMonitor(cameraId: string, labels: string[]) {
    return this.http.post(`${this.base}/monitor/set`, { camera_id: cameraId, labels });
  }

  setMonitorTargets(cameraId: string, targets: Array<{ id: number, label?: string }>) {
    return this.http.post(`${this.base}/monitor/set`, { camera_id: cameraId, targets });
  }

  selectBoxForMonitor(cameraId: string, bbox: [number, number, number, number]) {
    return this.http.post(`${this.base}/monitor/select_box`, { camera_id: cameraId, bbox });
  }

  getAlerts(cameraId: string) {
    return this.http.get(`${this.base}/alerts/${cameraId}`);
  }

  getDetections(cameraId: string) {
    return this.http.get(`${this.base}/detections/${cameraId}`);
  }

  registerObject(
    cameraId: string,
    objectId: string,
    label: string,
    files: File[]
  ) {
    const form = new FormData();
    form.append('camera_id', cameraId);
    form.append('object_id', objectId);
    form.append('label', label);

    files.forEach(f => form.append('files', f, f.name));

    return this.http.post(`${this.base}/object/register`, form);
  }

  setConnected(info: any) {
    this.connected = true;
    this.nvrInfo = info;
  }

  clearConnection() {
    this.connected = false;
    this.nvrInfo = null;
  }

  startWebcam() {
    return this.http.post(`${this.base}/webcam/start`, {});
  }

  stopWebcam() {
    return this.http.post(`${this.base}/webcam/stop`, {});
  }

  facesRegister(body: any) {
    return this.http.post(`${this.fcbase}https://objectdetection.anikinitek.com/api/faces/register`, body);
  }


  startRecognition(payload: {
    camera_id: string;
    rtsp_url?: string;
    device_index?: number;
  }) {
    console.log(payload.rtsp_url);
    return this.http.post(`${this.fcbase}recognize`, payload);
  }

  stopRecognition(payload: {
    camera_id: string;
  }) {
    return this.http.post(`${this.fcbase}recognize/stop`, payload);
  }


  uploadImage(name: any, files: any) {
    let formData = new FormData();
    formData.append('name', name);
    for (let list of files) {
      formData.append('files', list);
    }
    return this.http.post(this.fcbase + 'faces/register', formData)
  }

  facesPersons() {
    return this.http.get(`${this.fcbase}faces/persons`);
  }


  updateImage(id: any, name: any, files: any) {
    let formData = new FormData();
    formData.append('name', name);
    for (let list of files) {
      formData.append('files', list);
    }
    return this.http.put(this.fcbase + 'faces/' + id, formData)
  }


  facesImages(person_id: any) {
    return this.http.get(`${this.fcbase}faces/${person_id}/images`);
  }


  facesDeleteImages(body: any) {
    return this.http.post(`${this.fcbase}faces/delete-images`, body);
  }

}
